import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { company } from "@/lib/siteData";
import { directWhatsAppUrl } from "@/hooks/useWhatsAppMessage";

const navItems = [
  { label: "Início", href: "#" },
  { label: "Serviços", href: "#servicos" },
  { label: "Cidades", href: "#cidades" },
  { label: "Avaliações", href: "#avaliacoes" },
  { label: "Orçamento", href: "#orcamento" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const getHref = (href) => {
    if (href === "#") return isHomePage ? "#" : "/";
    return isHomePage ? href : `/${href}`;
  };

  return (
    <header className="site-header" data-testid="site-header-company-navigation">
      <Link className="brand-mark" to="/" data-testid="brand-home-link">
        <span className="brand-symbol" data-testid="brand-symbol">DA</span>
        <span>
          <strong data-testid="brand-trade-name">{company.tradeName}</strong>
          <small data-testid="brand-region">Londrina · Norte do Paraná</small>
        </span>
      </Link>

      <nav className="desktop-nav" aria-label="Navegação principal" data-testid="desktop-main-navigation">
        {navItems.map((item) => (
          <a key={item.href} href={getHref(item.href)} data-testid={`desktop-nav-link-${item.label.toLowerCase()}`}>
            {item.label}
          </a>
        ))}
      </nav>

      <a className="header-call" href={directWhatsAppUrl()} data-testid="header-whatsapp-button">
        <Phone size={18} aria-hidden="true" />
        {company.phoneDisplay}
      </a>

      <button className="mobile-menu-button" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle-button" aria-label="Abrir menu">
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>

      {open && (
        <div className="mobile-menu" data-testid="mobile-main-navigation">
          {navItems.map((item) => (
            <a key={item.href} href={getHref(item.href)} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}>
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};